import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
 Tabu: {  
     ...genStandard("tabu","/api/md"),
  },
};
export default api;
